define(['../validation'], function(validation) {
    'use strict';
    validation.addValidationRule('required', {
        type: 'custom',
        runFalsy: true,
        execute: function(val, options) {
            return typeof val !== 'undefined' && val !== null && val !== '';
        }
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/validation/rules/required.js
 ** module id = 105
 ** module chunks = 0
 **/